import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnChanges } from '@angular/core';

import { RichTextLink } from '@digital-platform/rs-cms/domain';
import { TrustarcCmComponent } from '@digital-platform/rs-shared/ui';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';
import { WindowService } from '../services/window.service';
import { NavigationHelperService } from '../utility/navigation-helper.service';

@Component({
  selector: 'digital-platform-rsx-a',
  templateUrl: './rich-text-link.component.html',
  styleUrls: ['./rich-text-link.component.scss'],
  standalone: true,
  imports: [CommonModule, TrustarcCmComponent],
})
export class RichTextLinkComponent
  extends BasePTypeComponent
  implements OnChanges, RichTextLink
{
  public override type = 'richTextLink' as const;

  @Input() public url: RichTextLink['url'] = '';
  @Input() public target: RichTextLink['target'] = undefined;
  @Input() public klass: string | string[] | null = '';
  @Input() public analyticsLinkText = '';
  @Input() public styling = '';

  public localHref = '';
  public isConsentPath = false;

  constructor(
    public readonly navigationHelperService: NavigationHelperService,
    @Inject(WindowService) protected windowService: Window
  ) {
    super();
  }

  public ngOnChanges() {
    this.localHref = this.navigationHelperService.getLocalHref(this.url);

    // Look for cookies links and set the isConsentLink flag
    // to render trustarc handler
    this.isConsentPath = this.localHref === 'cookies';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public navigate(event: Event, url: string): void {
    // Consent paths are handled by the trustarc handler
    if (this.isConsentPath) {
      return;
    }

    const shouldOpenNewTab = this.target === '_blank';

    this.navigationHelperService.navigate(event, url, shouldOpenNewTab);
  }
}
